import { AccessoriesPageData } from 'src/modules/accessories/AccessoriesPageMapping.ts';

type AccessoryItem = AccessoriesPageData['vssAccessories']['valveAccessories']['0'];
export const sortAccessories = (
    a: AccessoryItem,
    b: AccessoryItem,
) => `${a.item.zOption?.raw.join('') === '1' ? 'a' : 'z'}${a.item.Label}`
    .localeCompare(`${b.item.zOption?.raw.join('') === '1' ? 'a' : 'z'}${b.item.Label}`);
